import { createSelector } from '@reduxjs/toolkit';
import { getStore } from '../../reducers';

export const getFullscreenPreview = createSelector(getStore, (state) => state.fullscreenPreview);

export const getSingleAssetId = createSelector(
  getFullscreenPreview,
  (fullscreenPreview) => fullscreenPreview.singleAssetId,
);

export const getSingleAsset = createSelector(
  getFullscreenPreview,
  (fullscreenPreview) => fullscreenPreview.singleAsset,
);

export const getSingleAssetError = createSelector(
  getFullscreenPreview,
  (fullscreenPreview) => fullscreenPreview.singleAssetError,
);
